/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Studio_Step_QualityInputs */

const en_directory_ai_tools_studio_step_quality = /** @type {(inputs: Directory_Ai_Tools_Studio_Step_QualityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick quality`)
};

const zh_directory_ai_tools_studio_step_quality = /** @type {(inputs: Directory_Ai_Tools_Studio_Step_QualityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择画质`)
};

/**
* | output |
* | --- |
* | "Pick quality" |
*
* @param {Directory_Ai_Tools_Studio_Step_QualityInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_studio_step_quality = /** @type {((inputs?: Directory_Ai_Tools_Studio_Step_QualityInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Studio_Step_QualityInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_studio_step_quality(inputs)
	return zh_directory_ai_tools_studio_step_quality(inputs)
});
export { directory_ai_tools_studio_step_quality as "directory.ai_tools.studio.step_quality" }